import React, { useState } from 'react';
import { uk } from 'date-fns/locale';
import { DesktopTimePicker, LocalizationProvider, } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { toZonedTime } from 'date-fns-tz';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CustomInput, HorizontalBox, InputLabel1, InputTime, Label } from './BagTimeUpdate.styled';
import DatePicker from 'react-datepicker';
import { dayClassName, formatDate } from '../../../../utils/function';
import { TextField } from '@mui/material';
import './CustomDatePickerBagTime.css';
import { set } from 'date-fns';
import { showErrorToast, showWarningToast } from 'utils/showToast';
dayjs.extend(utc);
dayjs.extend(timezone);
const kyivTimeZone = 'Europe/Kyiv';
const parseDate = (dateString) => {

  const [day, month, year] = dateString.split('.').map(Number); // Розбиваємо рядок на частини
  const parsedDate = new Date(`${year}-${month}-${day}`);

  // Перевіряємо чи дата є валідною
  if (isNaN(parsedDate)) {
    console.error('Invalid Date:', dateString);
    return null;
  }
  console.log('parsedDate :>> ', parsedDate);
  return parsedDate;// Місяці в JavaScript починаються з 0, тому віднімаємо 1
};


const BagTimeUpdate = ({ startDate, setStartDate, dayFrom, dayTo, setDayFrom, setDayTo, deliveryDay, setDeliveryDay, firstTimeInitial, secondTimeInitial, setFirstTimeInitial, setSecondTimeInitial }) => {
  console.log('Запустилось вікно :>> ');
  console.log('Стартова дата startDate :>> ', startDate);
  // console.log('{ startDate, setStartDate, dayFrom, dayTo, setDayFrom, setDayTo } :>> ', { startDate, setStartDate, dayFrom, dayTo, setDayFrom, setDayTo });
  console.log('Перетворена дата dayjs(startDate, "DD.MM.YYYY"). :>> ', dayjs(startDate, "DD.MM.YYYY"));
  console.log('Час-Дата кошику з dayFrom :>> ', dayFrom);
  console.log('Час-Дата кошику до  dayTo :>> ', dayTo);

  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
 
  const [selectedDate, setSelectedDate] = useState(parseDate(startDate));

 
  const handleFirstTimeChange = (time) => {

    
     // Якщо час не вибрано, встановити на 00:00
     console.log('Зміна перешого часу');
     console.log('selectedDate :>> ', selectedDate);
    //  let newTime = dayjs(selectedDate).utc(true).tz(kyivTimeZone)
    //    .set('hour', time.hour())
    //    .set('minute', time.minute());
    // let newTime = dayjs(selectedDate).tz(kyivTimeZone, true)
    //   .set('hour', time.hour())
    //   .set('minute', time.minute());


    
     console.log('deliveryDay :>> ', deliveryDay);
     // Мінімальний час (поточний + 11 хвилин) у Києві
     const minAllowedTime = dayjs().tz(kyivTimeZone).add(11, 'minute');
 
     // Якщо сьогоднішній день, перевіряємо обмеження
     if (deliveryDay === "today") {
       if (time.isBefore(minAllowedTime)) {
         setFirstTimeInitial(minAllowedTime.toDate());
         setDayFrom(minAllowedTime.toDate())
         
       } else {
         setFirstTimeInitial(time);
         setDayFrom(time)
       }
     } else {
       setFirstTimeInitial(time);
       setDayFrom(time)
     }
     console.log('secondTime:>> ', secondTimeInitial);

   
    console.log('dayjs(secondTime):>> ', dayjs(secondTimeInitial));
     // Перевірка secondTime
    if (secondTimeInitial && time.isAfter(dayjs(secondTimeInitial))) {
       console.log('Час до менеше часу з:>> ');
       const newSecondTime = time.add(10, 'minute'); // Додаємо 10 хвилин
       setSecondTimeInitial(newSecondTime.toDate());
       setDayTo(time)
     }
     console.log('Закінчення зміни першого часу  ');
   };
 
   const handleSecondTimeChange = (time) => {
     console.log('Зміна другого часу');
     console.log('selectedDate :>> ', selectedDate);
 
    //  let newTime = dayjs(selectedDate).utc(true).tz(kyivTimeZone)
    //    .set('hour', time.hour())
    //    .set('minute', time.minute());
     
    //  let newTime = dayjs(selectedDate).tz(kyivTimeZone, true)
    //    .set('hour', time.hour())
    //    .set('minute', time.minute());
     
     console.log('newTime :>> ', time);
 
     const minAllowedTime = dayjs(firstTimeInitial).tz(kyivTimeZone);
 
     console.log('firstTime :>> ', firstTimeInitial);
     console.log('newTime.isBefore(minAllowedTime) :>> ', time.isBefore(minAllowedTime));
     console.log('minAllowedTime :>> ', minAllowedTime);



     if (time.isBefore(minAllowedTime)) {
       setSecondTimeInitial(minAllowedTime);
       setDayTo(minAllowedTime);
     } else {
       setSecondTimeInitial(time);
       setDayTo(time)
     }

     console.log('Закінчення зміни другого часу  ');
   };
  const handleDateChange = (date) => {
    console.log('Зміна дати');
    // Встановлюємо вибрану дату
    setSelectedDate(date);
    console.log('firstTime.: ', firstTimeInitial);
    console.log('Selected date (raw): ', date);
    console.log('secondTime.: ', secondTimeInitial);
    // Форматуємо дату без прив'язки до локального пояса
    const formattedDate = dayjs(date).format("DD.MM.YYYY");
    setStartDate(formattedDate);
    const firstTimeObj = dayjs(firstTimeInitial);
    const secondTimeObj = dayjs(secondTimeInitial);




    // Отримуємо години та хвилини з першої та другої дати
    const firstKyivTime = firstTimeObj.tz(kyivTimeZone);
    const secondKyivTime = secondTimeObj.tz(kyivTimeZone);

    // Встановлюємо час у київському часовому поясі без зміни години та хвилин
    const firstTimeInKyiv = dayjs(date)
      .hour(firstKyivTime.hour())
      .minute(firstKyivTime.minute())
      .second(firstKyivTime.second())
      .millisecond(firstKyivTime.millisecond())
      .tz(kyivTimeZone, true); // Конвертуємо в київський час без зміщення

    const secondTimeInKyiv = dayjs(date)
      .hour(secondKyivTime.hour())
      .minute(secondKyivTime.minute())
      .second(secondKyivTime.second())
      .millisecond(secondKyivTime.millisecond())
      .tz(kyivTimeZone, true); // Конвертуємо в київський час без зміщення

    console.log('dayFrom :>> ', firstTimeInKyiv.format());
    console.log('dayTo :>> ', secondTimeInKyiv.format());
    console.log('First time in Kyiv timezone: ', firstTimeInKyiv.format());
    console.log('Second time in Kyiv timezone: ', secondTimeInKyiv.format());

    setDayFrom(firstTimeInKyiv);
    setDayTo(secondTimeInKyiv);
    setFirstTimeInitial(firstTimeInKyiv);
    setSecondTimeInitial(secondTimeInKyiv);
    const today = dayjs().tz(kyivTimeZone).format("YYYY-MM-DD");
    const tomorrow = dayjs().tz(kyivTimeZone).add(1, 'day').format("YYYY-MM-DD");
    const selectedDay = dayjs(date).tz(kyivTimeZone).format("YYYY-MM-DD");

    console.log('today  :>> ', today);
    console.log('tomorrow :>> ', tomorrow);
    console.log('selectedDay: ', selectedDay);
  


    if (selectedDay === today) {
      setDeliveryDay("today");
    } else if (selectedDay === tomorrow) {
      setDeliveryDay("tomorrow");
    } else {
      setDeliveryDay("other");
    }
    console.log('Завершення зміни дати');

  };



  return (
    <HorizontalBox className='mobb' >
      <InputLabel1 htmlFor="startDate">День отримання

        <DatePicker
          id="startDate"
          selected={selectedDate} // Зберігаємо обрану дату
          minDate={dayjs().tz('Europe/Kyiv').startOf('day').toDate()} // Використовуємо дату у київській зоні для minDate
          dayClassName={dayClassName}
          onChange={handleDateChange}
          onCalendarOpen={() => setIsCalendarOpen(true)}
          onCalendarClose={() => setIsCalendarOpen(false)}
          dateFormat="dd.MM.yyyy"
          locale={uk}
          calendarStartDay={1}
          customInput={
            <label>
              <CustomInput
                type="text"
                name="birthDay"
                className={isCalendarOpen ? "open-calendar" : ""}
                value={startDate}
                onChange={() => { console.log('start :>> '); }}
              />
            </label>
          }
        />
      </InputLabel1>

      <Label htmlFor="deliveryTime">Час отримання
        <HorizontalBox>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopTimePicker

              id="deliveryTime1"
              minTime={
                dayjs(selectedDate).isSame(dayjs().tz(kyivTimeZone), 'day')
                  ? dayjs().tz(kyivTimeZone).add(2, 'minute')
                  : null
              } // Мінімальний час у Києві
              value={firstTimeInitial ? dayjs(firstTimeInitial).tz(kyivTimeZone) : null}
              onChange={handleFirstTimeChange}
              ampm={false} // 24-годинний формат
              timeSteps={{ minutes: 1 }}// Інтервал в 1 хвилину
              renderInput={(params) => <InputTime {...params} />} // Використання кастомного інпуту для введення часу
            />
          </LocalizationProvider>

          -


          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopTimePicker
              id="deliveryTime2"
              minTime={firstTimeInitial ? dayjs(firstTimeInitial).tz(kyivTimeZone) : null}
              value={secondTimeInitial ? dayjs(secondTimeInitial).tz(kyivTimeZone) : null}
              onChange={handleSecondTimeChange}

              ampm={false} // 24-годинний формат
              // Мінімальний час - вибраний початковий час або 00:00
              renderInput={(params) => <TextField className="custom-time-picker" // Додати клас
                variant="outlined" {...params} />} // Використання кастомного інпуту для введення часу
            />
          </LocalizationProvider>


        </HorizontalBox>
      </Label>
    </HorizontalBox>
  );
};

export default BagTimeUpdate;